import component from './CustomOptionsPicker.vue'
export default component
